import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function SettingsCard() {
  const { t } = useTranslation();
  const [notifications, setNotifications] = useState(true);
  const [reminders, setReminders] = useState(true);

  return (
    <div className="bg-white rounded-[2.5rem] p-2 shadow-[0_8px_40px_rgba(0,0,0,0.04)] border border-stone-100 flex flex-col">
      <ToggleRow label={t('settings.notifications')} checked={notifications} onChange={setNotifications} />
      <ToggleRow label={t('settings.dailyReminders')} checked={reminders} onChange={setReminders} hideBorder />
    </div>
  );
}

function ToggleRow({ label, checked, onChange, hideBorder }: { label: string, checked: boolean, onChange: (v: boolean) => void, hideBorder?: boolean }) {
  return (
    <div className={`flex items-center justify-between p-5 px-6 ${!hideBorder ? 'border-b border-stone-50' : ''}`}>
      <span className="text-[15px] font-bold text-stone-700 tracking-tight">{label}</span>
      <button
        onClick={() => onChange(!checked)}
        className={`w-12 h-7 rounded-full transition-colors relative shadow-inner ${checked ? 'bg-emerald-500' : 'bg-stone-200'}`}
      >
        <div className={`w-6 h-6 bg-white rounded-full absolute top-0.5 transition-transform shadow-md ${checked ? 'translate-x-5.5 left-0' : 'translate-x-0.5 left-0'}`} />
      </button>
    </div>
  );
}
